import React from 'react';
import {
  Box,
  Card,
  CardBody,
  Heading,
  Text,
  Button,
  VStack,
  Icon,
  useColorModeValue,
  Flex
} from '@chakra-ui/react';
import { UserPlus, Key, ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export default function RequestAccessCard() {
  const cardBg = useColorModeValue('white', 'gray.800');
  const overlayBg = 'linear-gradient(135deg, rgba(45, 74, 79, 0.9) 0%, rgba(78, 205, 196, 0.8) 100%)';
  const navigate = useNavigate();
  const accentColor = '#8bc34a';

  const handleAccessRequest = () => {
    // Qui andrà la navigazione verso la pagina del form
    console.log('Navigating to access request form...');
  };

  return (
    <Card
      bg={cardBg}
      borderRadius="lg"
      overflow="hidden"
      position="relative"
      h="100%"
      cursor="pointer"
      transition="all 0.3s ease"
      _hover={{
        transform: 'translateY(-4px)',
        boxShadow: '0 20px 40px rgba(0,0,0,0.1)'
      }}
      onClick={handleAccessRequest}
    >
      {/* Background Pattern */}
      <Box
        position="absolute"
        top="0"
        left="0"
        right="0"
        bottom="0"
        bg="radial-gradient(circle at 20% 30%, rgba(255,255,255,0.1) 2px, transparent 2px),
            radial-gradient(circle at 80% 70%, rgba(255,255,255,0.08) 1px, transparent 1px),
            radial-gradient(circle at 40% 80%, rgba(255,255,255,0.06) 1.5px, transparent 1.5px)"
        bgSize="60px 60px, 40px 40px, 80px 80px"
        opacity="0.4"
      />
      
      {/* Gradient Overlay */}
      <Box
        position="absolute"
        top="0"
        left="0"
        right="0"
        bottom="0"
        bg={overlayBg}
      />

      {/* Content */}
      <CardBody
        position="relative"
        zIndex="2"
        display="flex"
        flexDirection="column"
        justifyContent="space-between"
        h="full"
        p={6}
      >
        <VStack spacing={3} align="start" flex="1">
          {/* Icon Header */}
          <Flex align="center" gap={2}>
            <Box
              p={2}
              borderRadius="lg"
              bg="rgba(255,255,255,0.2)"
              backdropFilter="blur(10px)"
            >
              <Icon as={UserPlus} boxSize={6} color="white" />
            </Box>
            <Box
              p={1.5}
              borderRadius="md"
              bg="rgba(139,195,74,0.9)"
            >
              <Icon as={Key} boxSize={4} color="white" />
            </Box>
          </Flex>

          {/* Title */}
          <Heading 
            size="xl" 
            color="white" 
            fontWeight="bold"
            lineHeight="shorter"
          >
            Richiedi Accesso
          </Heading>

          {/* Description */}
          <VStack spacing={2} align="start">
            <Text 
              color="white" 
              fontSize="md" 
              fontWeight="medium"
              opacity="0.95"
            >
              Ottieni le tue credenziali per AMELIA
            </Text>
            
            <Text 
              color="white" 
              fontSize="sm" 
              opacity="0.85"
              lineHeight="base"
            >
              Completa il form di richiesta per avviare il processo di registrazione. 
              Riceverai userID e password per accedere alla piattaforma dati.
            </Text>

            {/* Process Steps - Compacted */}
            <VStack spacing={1} align="start" mt={1}>
              <Flex align="center" gap={2}>
                <Box w="4px" h="4px" borderRadius="full" bg={accentColor} />
                <Text color="white" fontSize="xs" opacity="0.8">
                  Compila modulo responsabilità
                </Text>
              </Flex>
              <Flex align="center" gap={2}>
                <Box w="4px" h="4px" borderRadius="full" bg={accentColor} />
                <Text color="white" fontSize="xs" opacity="0.8">
                  Validazione richiesta
                </Text>
              </Flex>
              <Flex align="center" gap={2}>
                <Box w="4px" h="4px" borderRadius="full" bg={accentColor} />
                <Text color="white" fontSize="xs" opacity="0.8">
                  Ricezione credenziali
                </Text>
              </Flex>
            </VStack>
          </VStack>
        </VStack>

        {/* Call to Action */}
        <Button
          variant="ghost"
          color="white"
          size="lg"
          rightIcon={<Icon as={ArrowRight} />}
          _hover={{
            bg: 'rgba(255,255,255,0.1)',
            transform: 'translateX(4px)'
          }}
          _active={{
            bg: 'rgba(255,255,255,0.2)'
          }}
          transition="all 0.2s ease"
          justifyContent="space-between"
          w="full"
          mt={4}
          borderRadius="lg"
          py={6}

          onClick={()=> {
           // navigate("/request-access")
          }}
        >
          <Text fontWeight="semibold">Richiedi Accesso</Text>
        </Button>
      </CardBody>

      {/* Decorative Elements */}
      <Box
        position="absolute"
        top="15px"
        right="15px"
        w="60px"
        h="60px"
        borderRadius="full"
        bg="rgba(255,255,255,0.1)"
        opacity="0.5"
      />
      <Box
        position="absolute"
        bottom="20px"
        right="30px"
        w="30px"
        h="30px"
        borderRadius="full"
        bg="rgba(139,195,74,0.3)"
        opacity="0.7"
      />
    </Card>
  );
}